import Metrics from '../Metrics'
import { BoxSizes, Chart, Dashboard } from './types'

const EventSpace2: Dashboard = {
  id: 'ES2',
  name: 'Event Space 2',
  daterange: true,
  metrics: [
    {
      type: Metrics.EVENTSPACE2_DEVICES_ONLINE,
      'box-size': BoxSizes.MID,
      chart: Chart.Doughnut,
      count: 'dashboard-count-devices',
      title: 'dashboard-devices-online',
    },
    {
      type: Metrics.EVENTSPACE2_DWELLTIMELINE,
      'box-size': BoxSizes.BIG,
      chart: Chart.Timeline,
      color: '#2f9b8f',
      title: 'dashboard-eventspace-dwelltimeline',
      count: 'dashboard-count-seconds-average',
    },
    {
      type: Metrics.EVENTSPACE2_STORES_TOP,
      'box-size': BoxSizes.MID,
      chart: Chart.List,
      title: 'dashboard-stores-top',
      count: 'dashboard-count-stores',
      'count-data': 'dashboard-count-interactions',
    },
    {
      type: Metrics.EVENTSPACE2_INTERACTIONS_GROUPED,
      'box-size': BoxSizes.MID,
      chart: Chart.Bars,
      title: 'dashboard-interactions-grouped',
      count: 'dashboard-count-interactions',
      'count-data': 'dashboard-count-interactions',
    },
    {
      type: Metrics.GROUP,
      'box-size': BoxSizes.THIRD,
      metrics: [
        {
          type: Metrics.EVENTSPACE2_CONTENT_TOP,
          'box-size': BoxSizes.FULLWIDTH,
          title: 'dashboard-content-top',
        },
      ],
    },
  ],
}

export default EventSpace2
